import { render, staticRenderFns } from "./News.vue?vue&type=template&id=6f733542&"
import script from "./News.ts?vue&type=script&lang=ts&"
export * from "./News.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports